import { useState } from 'react';
import { Project } from '@bulthaup/api/db';
import { Button, Group, Stack, Text } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import { notifications } from '@mantine/notifications';
import { isEqual, pick } from 'lodash';

import { trpc } from '../../../../../services/trpc';

const FIELDS_TO_COMPARE = [
  'installationDate',
  'endOfInstallationDate',
] as const;

export function InstallationSection({ project }: { project: Project }) {
  const utils = trpc.useUtils();
  const [localValues, setLocalValues] = useState(
    pick(project, FIELDS_TO_COMPARE),
  );
  const [hasChanges, setHasChanges] = useState(false);

  const update = trpc.projects.updateInstallationDates.useMutation({
    onSuccess: () => {
      notifications.show({
        title: 'Succès',
        message: "Date d'installation mise à jour",
        color: 'green',
      });
      utils.projects.get.invalidate({ slug: project.slug });
      setHasChanges(false);
    },
    onError: error => {
      notifications.show({
        title: 'Erreur',
        message: error.message,
        color: 'red',
      });
    },
  });

  const handleChange = (field: string, value: Date | null) => {
    const newValues = {
      ...localValues,
      [field]: value,
    };

    setLocalValues(newValues);
    setHasChanges(
      !isEqual(
        pick(newValues, FIELDS_TO_COMPARE),
        pick(project, FIELDS_TO_COMPARE),
      ),
    );
  };

  const handleSave = async () => {
    await update.mutateAsync({
      id: project.id,
      installationDate: localValues.installationDate ?? null,
      endOfInstallationDate: localValues.endOfInstallationDate ?? null,
    });
  };

  return (
    <Stack>
      <Group>
        <Text style={{ flex: 1 }}>Date d'installation :</Text>
        <DateInput
          withWeekNumbers
          placeholder="Sélectionner une date"
          valueFormat="DD/MM/YYYY"
          clearable
          value={localValues.installationDate || null}
          onChange={date => {
            handleChange('installationDate', date ? new Date(date) : null);
          }}
          style={{ width: 200 }}
        />
      </Group>
      <Group>
        <Text style={{ flex: 1 }}>Fin de chantier :</Text>
        <DateInput
          withWeekNumbers
          placeholder="Sélectionner une date"
          valueFormat="DD/MM/YYYY"
          clearable
          value={localValues.endOfInstallationDate || null}
          onChange={date => {
            handleChange('endOfInstallationDate', date ? new Date(date) : null);
          }}
          style={{ width: 200 }}
        />
      </Group>
      {hasChanges && (
        <Group justify="flex-end">
          <Button onClick={handleSave} loading={update.isPending}>
            Sauvegarder
          </Button>
        </Group>
      )}
    </Stack>
  );
}
